import axios from "axios"

export const authenticate = (userDetails) =>
  axios.post("/api/webUsers/authenticate", userDetails)

export const verifyCode = (challengeId, code) =>
  axios.post("/api/webUsers/verifyCode", { challengeId, code })

export const resendCode = (challengeId) =>
  axios.post("/api/webUsers/resendCode", { challengeId })

export const refresh = (token, refreshToken) =>
  axios.post("/api/webUsers/refresh", { token, refreshToken })
